<script>
    import {elementsSettingsLimits} from "./settingsDefinition";

    export default {
        data: function () {
            return {
                temp_active_value: undefined,
                temp_active_field: undefined,
                date_format_mapping: {
                    'dd.MM.yyyy': 'DD.MM.yyyy',
                    'MM/dd/yyyy': 'MM/DD/yyyy'
                },
                outlined: true,
                dense: true,
            };
        },
        methods: {
            propertyAvailable: function (property) {
                return this.elementProperties()?.[property] ?? null;
            },
            element_readonly: function(property) {
                if(this.readonly) {
                    return true;
                }
                const priv = this.propertyAvailable(property);
                if(priv?.['edit_rights'] === 'advanced') {
                    return !this.advancedPrivilege;
                }
                if(priv?.['edit_rights'] === 'basic') {
                    return !(this.basicPrivilege || this.advancedPrivilege);
                }
                return true;
            },
            element_locked: function(property) {
                if(this.locked) {
                    return true;
                }
                return this.element_readonly(property);
            },
            field_min(field) {
                let limits = this.getFieldLimits(field);
                return limits['min'];
            },
            field_max(field) {
                let limits = this.getFieldLimits(field);
                return limits['max'];
            },
            field_rules(field) {
                let limits = this.getFieldLimits(field);
                let rules = [];
                if (limits) {
                    if ('min' in limits) {
                        rules.push(value => value >= limits.min || Lang.langGet('Min :val', {'val': limits.min}));
                    }
                    if ('max' in limits) {
                        rules.push(value => value <= limits.max || Lang.langGet('Max :val', {'val': limits.max}));
                    }
                    if (!('empty' in limits)) {
                        rules.push(value => !!value || Lang.langGet('Required'));
                    }
                    if (limits['type'] === 'number' || !('number' in limits)) {
                        if (!('float' in limits)) {
                            rules.push(value =>  value % 1 === 0 || Lang.langGet('Must be an integer'));
                        }
                    }
                    if ('length' in limits) {
                        rules.push(value => value.length <= limits.length || Lang.langGet('Max :val characters', {'val': limits.length}));
                    }
                    if (limits['type'] === 'email') {
                        rules.push(value => {
                            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                            return pattern.test(value) || Lang.langGet('Invalid e-mail')
                        });
                    }
                }
                return rules;
            },
            getRules() {
                let rules = {};
                Object.keys(this.elementProperties()).forEach((name) => {
                    rules[name] = this.field_rules(name);
                });
                return rules;
            },
            innerFieldFocus: function(field) {
                this.temp_active_field = field;
                this.temp_active_value = this.inner_properties[field];
            },
            innerFieldBlur: function(field, limits=null) {
                if(this.temp_active_field === field) {
                    this.innerPropertySetter(field, this.temp_active_value, limits);
                } else {
                    console.log('error: field Blur without focus');
                }
                this.temp_active_field = undefined;
                this.temp_active_value = undefined;
            },
            innerFieldEnter: function(field, limits=null) {
                if(this.temp_active_field === field) {
                    this.temp_active_value = this.innerPropertySetter(field, this.temp_active_value, limits);
                } else {
                    console.log('error: field Enter without focus');
                }
            },
            innerFieldGetter: function(field, default_value=null) {
                let ret_val = null;
                if(this.temp_active_field === field) {
                    ret_val = this.temp_active_value;
                } else {
                    ret_val = this.inner_properties[field];
                }
                if(!ret_val && default_value) {
                    ret_val = default_value;
                }
                return ret_val;
            },
            innerFieldSetter: function(field, val) {
                if(this.temp_active_field === field) {
                    this.temp_active_value = val;
                } else {
                    console.log('error: field Setter without focus');
                }
            },
            innerPropertySetter: function(field, val, limits=null) {
                let oldVal = this.inner_properties[field];
                if (limits === null){
                    limits = this.getFieldLimits(field);
                }
                let clamped = val;
                if(limits) {
                    if (limits.color === 1) {
                        if (!val) {
                            val = '';
                        }
                        if (!oldVal) {
                            oldVal = '';
                        }
                        val = parseInt(val.replace('#', ''), 16);
                        oldVal = parseInt(oldVal.replace('#', ''), 16);
                    }
                    clamped = this.clampToLimits(val, oldVal, limits);
                    if (limits.color === 1) {
                        clamped = '#' + clamped.toString(16).padStart(6, '0');
                    }
                }
                Vue.set(this.inner_properties, field, 0);
                Vue.set(this.inner_properties, field, clamped);
                return clamped;
            },
            getFieldEvaluatedLimits(field) {
                let limits = this.getFieldLimits(field);
                let bounds = this.getFieldBounds(limits);
                if (bounds) {
                    limits.min = bounds.min;
                    limits.max = bounds.max;
                }
                return limits
            },
            getFieldLimits(field, type="") {
                if(type == null) {
                    type = this.inner_properties.type;
                }
                let limits = null;
                if (type in elementsSettingsLimits && field in elementsSettingsLimits[type]) {
                    limits = elementsSettingsLimits[type][field];
                } else if ("default" in elementsSettingsLimits && field in elementsSettingsLimits["default"]) {
                    limits = elementsSettingsLimits["default"][field];
                }

                return limits;
            },
            getFieldBounds(limits, properties=null, inner=null) {
                if (typeof limits === 'object' && limits != null) {
                    let inner_allowed = (inner != null);
                    if(!properties) {
                        properties = this.inner_properties;
                        inner_allowed = true;
                    }
                    if(!inner && inner_allowed) {
                        inner = this;
                    }

                    var min = Number.MIN_SAFE_INTEGER;
                    var max = Number.MAX_SAFE_INTEGER;
                    var fallback_min = Number.MIN_SAFE_INTEGER;
                    var fallback_max = Number.MAX_SAFE_INTEGER;

                    min = limits.min != null ? limits.min : min;
                    max = limits.max != null ? limits.max : max;
                    fallback_min = (typeof min == "string" && limits.fallback_min != null) ? limits.fallback_min : fallback_min;
                    fallback_max = (typeof max == "string" && limits.fallback_max != null) ? limits.fallback_max : fallback_max;

                    if(typeof fallback_min === "string") {
                        fallback_min = fallback_min.startsWith("inner_") ? (inner_allowed ? inner[fallback_min] : null) : properties[fallback_min];
                        fallback_min = (fallback_min == null || fallback_min === '') ? Number.MIN_SAFE_INTEGER : fallback_min;
                    }
                    if(typeof fallback_max === "string") {
                        fallback_max = fallback_max.startsWith("inner_") ? (inner_allowed ? inner[fallback_max] : null) : properties[fallback_max];
                        fallback_max = (fallback_max == null || fallback_max === '') ? Number.MAX_SAFE_INTEGER : fallback_max;
                    }
                    if(typeof min === "string") {
                        min = min.startsWith("inner_") ? (inner_allowed ? inner[min] : null) : properties[min];
                        min = (min == null || min === '') ? fallback_min : min;
                    }
                    if(typeof max === "string") {
                        max = max.startsWith("inner_") ? (inner_allowed ? inner[max] : null) : properties[max];
                        max = (max == null || max === '') ? fallback_max : max;
                    }

                    return {min: Number(min), max: Number(max)}
                }
                return null;
            },
            clampToLimits(value, oldValue, limits, properties=null, inner=null) {
                if (value !== '' && value !== undefined && typeof limits === 'object' && limits != null) {
                    let bounds = this.getFieldBounds(limits, properties, inner);

                    value = limits.float ? Math.round(parseFloat(value, 10) * 10) / 10.0 : parseInt(value, 10);
                    if (isNaN(value)) {
                        value = oldValue;
                    }

                    if (value < bounds[0])
                        return bounds[0];
                    if (value > bounds[1])
                        return bounds[1];
                }
                return value;
            },
            getLayerNr: function (ids) {
                let layers = [],
                    idsNormalized = [];

                _.forEach(ids, function (value) {
                    idsNormalized.push(String(value));
                });

                _.forEach(this.all_layer_layers, function (value) {
                    if (_.indexOf(idsNormalized, String(value.value)) !== -1) {
                        layers.push(typeof value.nr !== 'undefined' ? value.nr : value.id);
                    }
                });

                return layers;
            },
            formatColor: function (colorpickerVal) {
                let value = parseInt(colorpickerVal.replace('#', ''), 16);
                value = value.toString(16).padStart(6, '0');
                value = '#' + value.substr(value.length - 6);
                return value;
            },
        },
        mounted: function () {
            EaseEventBus.listen('innerFieldValueChange', (data) => {
                if(this.temp_active_field === data[0]) {
                    this.innerFieldSetter(data[0], data[1]);
                }
            });
        }
    }
</script>
